import styled from 'styled-components';
import { mediumBreakpoint } from 'utilities/constants';

export const Container = styled.div`
  position: relative;
  width: 100%;
  vertical-align: top;
  border: solid #f1f1f1;
  border-width: 1px 0 0;

  @media (max-width: ${mediumBreakpoint}px) {
    border-width: 0 0 1px;
  }
`;

export const Inner = styled.div`
  vertical-align: top;
  position: relative;
  max-width: 100%;
  border-radius: inherit;
`;
